import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLolRoleJun = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 15,
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1088_5802)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_1088_5802)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M10.3523 13.5004L12.7536 11.4765C12.7536 11.4765 12.5883 6.48565 15.4845 4.27362C15.4833 4.27242 10.556 5.18791 10.3523 13.5004Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.77707 9.28364L9.84178 9.1039C10.1342 8.28906 10.3558 7.45027 10.4996 6.59709C10.8316 4.63431 11.5769 0.81659 12.5559 -0.651303C13.8992 -2.66561 8.52607 4.65228 8.5033 5.99556L9.77707 9.28364Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.04078 16C8.04078 16 11.2054 9.37707 3.4262 -0.457214C3.4262 -0.457214 5.98213 5.71033 5.48245 8.98883C5.48245 8.98883 3.71259 4.74092 0.5 4.1993C0.5 4.1993 3.32554 7.29566 3.20931 11.3195L8.04078 16Z",
					fill: "currentColor"
				})
			]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1088_5802",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white",
			transform: "translate(0.5)"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_1088_5802",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14.9833,
			height: 17,
			fill: "white",
			transform: "translate(0.5 -1)"
		})
	})] })]
});
export default SvgLolRoleJun;
